import Home from './pages/Home';

export default function App() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-100">
      <Home />
    </div>
  );
}
